import React from 'react';
import VisitorAnalytics from './VisitorAnalytics';

const AnalyticsAnalytics = () => {
  return (
    <div className="analytics-analytics">
      <VisitorAnalytics />
    </div>
  );
};

export default AnalyticsAnalytics;

